module.exports = __webpack_public_path__ + "static/media/boi.b646fba5.jpg";